'use client';

import { c as _c } from "react/compiler-runtime";
import '#components/chart/chart.css';
import { ChartConfig, ChartConfigProps } from '#components/chart/context/ChartConfig';
import { LineChart } from '#components/chart/LineChart';
import { ParseChartData } from '#components/chart/types';
export const Chart = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LineChart />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <ChartConfig {...props}>{t0}</ChartConfig>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};